var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pipeline-triggerer",attrs:{"data-testid":"pipeline-triggerer"}},[(_vm.user)?_c('gl-avatar-link',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],staticClass:"gl-ml-3",attrs:{"href":_vm.userPath,"title":_vm.user.name}},[_c('gl-avatar',{attrs:{"size":32,"src":_vm.avatarUrl}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }